import { Entity } from "@rhinov/savane-js";
import { PetalsTabController } from "../PetalsTabController";

export class PetalsTabWidget {

    parent: HTMLElement;
    controller: PetalsTabController;

    openPetal = (event: Event) => {
        this.controller.petalFunction((event.currentTarget as any)._param);
        this.controller.updatePropertiesElement();
    }

    setDropDownValue = (event: Event) => {
        var id = (event.currentTarget as any)._param;
        this.controller.setDropdownProperty(id);
        this.handledropdown();
    }

    handleclose = (event: Event) => {
        let drop_down = document.getElementById('dropdown_select');
        if (drop_down && !drop_down.contains(event.target as Node)) {
            let list = document.getElementById('tulipDropDownMenu');
            if (list) {
                list.style.display = "none";
            }
        }
    }

    handledropdown = () => {
        let list = document.getElementById('tulipDropDownMenu');
        if (list) {
            if (list.style.display === "none") {
                list.style.display = "block";
            } else {
                list.style.display = "none";
            }
        }
    }

    constructor(tulipItem: Entity, urlconfig: string, openAssetDetailCallback: CallableFunction, deliverable: any, user: any, designer: any) {
        this.parent = document.getElementById('tulipEditionTabs')!;
        var element = document.getElementById('tulip-plan');
        if (element) {
            element.classList.add('hide');
        }
        this.controller = new PetalsTabController(tulipItem, urlconfig, openAssetDetailCallback, deliverable, user, designer, () => {
            this.parent.innerHTML = this.html();
            setTimeout(() => {
                this.controller.updatePropertiesElement()
                setTimeout(() => {
                    this.setListener();
                    if (element) {
                        element.classList.remove('hide');
                    }
                }, 50)
            }, 50);
        });
    }

    buildIcon(petal: any): string {
        var html = "";
        if (!petal.iconsNbPath) return "";
        petal.iconsNbPath.forEach((nb: number) => {
            html += `
                <span class="${'path' + nb}"></span>
                <!-- Don't no what it used for but maybe a path ? -->
            `;
        })
        return html;
    }

    petalListHtml(): string {
        var html = "";
        this.controller.petals.forEach(petal => {
            html += `
                <div class="btn-group petal" class="${petal === this.controller.petals[0] && !this.controller.dropdown ? 'first' : ""}${petal === this.controller.petals[this.controller.petals.length - 1] ? 'last': ""}">
                    <button style="margin:7px 7px 7px 7px;display: ${this.controller.hidePetal(petal) ? "none" : ""}" type="button" class="btn btn-flat ${petal.class !== undefined ? petal.class : ''}"
                        title="${petal.title}" id="${petal.title}">
                        <span class="material-icons ${petal.icon}">
                           ${this.buildIcon(petal)}
                        </span>
                    </button>
                    ${petal !== this.controller.petals[this.controller.petals.length - 1] ? `
                        <div id="${petal.title}-div" class="divider-vertical" style="display: ${this.controller.hidePetal(petal) || this.controller.isLastNotHidden(petal, this.controller.petals) ? "none" : ""}"></div>
                        `: ""}
                </div>
            `;
            
        });
        return html;
    }

    dropdownList(): string {
        var html = "";
        this.controller.dropdownData.forEach(option => {
            html+= `
                <li class="primaryLabel ${this.controller.isDropdownValueActive(option.id) ? 'active' : ''}" id="${option.name}"
                    value="${option.id}">
                    <div><img style="opacity: 0;margin-left:5px;margin-right:5px">
                        ${option.name}
                    </div>
                </li>
            `
        })
        return html;
    }

    html(): string {
        return `
            <!-- TABS for each petals -->
            <div class="btn-group petal petal-dropdown" style="display:${this.controller.dropdown ? "" : "none"}">
                <div id="dropdown_select" class="col-xs-12" style="padding-left:0;padding-right:0">
                    <div style="margin-top:7px;margin-left: 10px;margin-right: 10px" class="btn-group">
                        <button id="dropdownValue" type="button" class="btn btn-flat  btn-primary borderless">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu roomDropDownMenu rhinov" id="tulipDropDownMenu"
                            style="overflow:auto;max-height:200px;min-width: 200px; display: none" role="menu"
                            aria-labelledby="single-button">
                            ${this.dropdownList()}
                        </ul>
                    </div>
                    <div class="divider-vertical pull-right"></div>
                </div>
            </div>

            ${this.petalListHtml()}
    `;
    }

    setListener() {
        let dropbutton = document.getElementById('dropdownValue');
        if (dropbutton) {
            dropbutton.addEventListener('click', this.handledropdown);
        }
        document.addEventListener('click', this.handleclose);
        this.controller.dropdownData.forEach(option => {
            let element = document.getElementById(option.name) as HTMLElement & {_param: number};
            if (element) {
                element._param = option.id;
                element.addEventListener('click', this.setDropDownValue)
            }
        })
        this.controller.petals.forEach(petal => {
            let button = document.getElementById(petal.title) as HTMLElement & {_param: any};
            if (button) {
                button._param = petal;
                button.addEventListener('click', this.openPetal)
            }
        })
    }

    removeListener() {
        let dropbutton = document.getElementById('dropdownValue');
        if (dropbutton) {
            dropbutton.removeEventListener('click', this.handledropdown);
        }
        document.removeEventListener('click', this.handleclose);
        this.controller.dropdownData.forEach(option => {
            let element = document.getElementById(option.name);
            if (element) {
                element.removeEventListener('click', this.setDropDownValue)
            }
        })
        this.controller.petals.forEach(petal => {
            let button = document.getElementById(petal.title);
            if (button) {
                button.removeEventListener('click', this.openPetal);
            }
        })
    }

    destroy() {
        this.removeListener();
        this.controller.hideTab();
        return;
    }
}
